/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signin_Code_WrongInputs */

const en_signin_code_wrong = /** @type {(inputs: Signin_Code_WrongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That code did not match. Check the app and try again.`)
};

/** @type {(inputs: Signin_Code_WrongInputs) => LocalizedString} */
const ar_signin_code_wrong = en_signin_code_wrong;

/** @type {(inputs: Signin_Code_WrongInputs) => LocalizedString} */
const he_signin_code_wrong = en_signin_code_wrong;

/** @type {(inputs: Signin_Code_WrongInputs) => LocalizedString} */
const ur_signin_code_wrong = en_signin_code_wrong;

/** @type {(inputs: Signin_Code_WrongInputs) => LocalizedString} */
const es_signin_code_wrong = en_signin_code_wrong;

/** @type {(inputs: Signin_Code_WrongInputs) => LocalizedString} */
const fr_signin_code_wrong = en_signin_code_wrong;

/** @type {(inputs: Signin_Code_WrongInputs) => LocalizedString} */
const de_signin_code_wrong = en_signin_code_wrong;

/** @type {(inputs: Signin_Code_WrongInputs) => LocalizedString} */
const pt_signin_code_wrong = en_signin_code_wrong;

/** @type {(inputs: Signin_Code_WrongInputs) => LocalizedString} */
const hi_signin_code_wrong = en_signin_code_wrong;

/** @type {(inputs: Signin_Code_WrongInputs) => LocalizedString} */
const bn_signin_code_wrong = en_signin_code_wrong;

/**
* | output |
* | --- |
* | "That code did not match. Check the app and try again." |
*
* @param {Signin_Code_WrongInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const signin_code_wrong = /** @type {((inputs?: Signin_Code_WrongInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signin_Code_WrongInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_signin_code_wrong(inputs)
	if (locale === "he") return he_signin_code_wrong(inputs)
	if (locale === "ur") return ur_signin_code_wrong(inputs)
	if (locale === "es") return es_signin_code_wrong(inputs)
	if (locale === "fr") return fr_signin_code_wrong(inputs)
	if (locale === "de") return de_signin_code_wrong(inputs)
	if (locale === "pt") return pt_signin_code_wrong(inputs)
	if (locale === "hi") return hi_signin_code_wrong(inputs)
	if (locale === "bn") return bn_signin_code_wrong(inputs)
	return /** @type {LocalizedString} */ ("That code did not match. Check the app and try again.")
});